export enum ResetState {
    init = 'init',
    code = 'code',
    setPassword = 'setPassword',
}
